import React from 'react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Paper,
  TextField,
  InputAdornment,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Radio,
} from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import CustomFooter from '../../../../components/Table/CustomFooter';
class FixedEmergencyDeviceView extends React.PureComponent {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    const { classes, t, devices } = this.props;
    const count = devices.data ? devices.pagination.count : 0;
    const page = devices.data ? devices.pagination.page - 1 : 0;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle className='header' id='form-dialog-title' style={{ padding: '16px 24px 0px' }}>
          {t('wizard_select_device')}
          <label className='badge badge-base'>
            {count} {t('devices')}
          </label>
        </DialogTitle>
        <DialogContent style={{ overflow: 'hidden', padding: 0 }}>
          <Grid container spacing={16} style={{ padding: '8px 20px' }}>
            <Grid item sm={6} xs={12}>
              <TextField
                required
                id='search'
                name='search'
                fullWidth
                value={this.props.search || ''}
                onChange={(e) => this.props.handleSearch('search', e.target.value)}
                variant='outlined'
                margin='dense'
                placeholder={t('wizard_search_device')}
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                  startAdornment: (
                    <InputAdornment position='start'>
                      {' '}
                      <svg width='24' height='24' viewBox='0 0 24 24'>
                        <use xlinkHref={`/images/menus-v1.svg#search`} />
                      </svg>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paperTable}>
              <div style={{ overflow: 'auto', maxHeight: '320px' }}>
                <Table>
                  <TableHead>
                    <TableRow style={{ border: 'none', height: 35 }}>
                      <CustomTableCell style={{ paddingLeft: 60 }}>{t('device_name')}</CustomTableCell>
                      <CustomTableCell>{t('wizard_device_serail')}</CustomTableCell>
                      <CustomTableCell>{t('wizard_device_type')}</CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(this.props.devices.data || []).map((device, i) => (
                      <TableRow key={i}>
                        <CustomTableCell
                          component='th'
                          scope='row'
                          className={device.mapId ? classes.textDisable : classes.textColor}
                        >
                          <Grid container alignItems='center'>
                            <Radio
                              id={`radio-${device.id}`}
                              checked={this.props.devicePoint.id === device.id}
                              value={device.id}
                              name='routerId'
                              color='primary'
                              onChange={(e) => {
                                this.props.handleChange(e);
                              }}
                              disabled={device.mapId ? true : false}
                            />
                            {device.place || device.name}
                          </Grid>
                        </CustomTableCell>
                        <CustomTableCell
                          component='th'
                          scope='row'
                          className={device.mapId ? classes.textDisable : classes.textColor}
                        >
                          {device.serial}
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row' style={{ fontSize: 12 }}>
                          <label className={`badge ${device.mapId ? 'badge-disabled' : 'badge-wizard-error'}`}>
                            <span className='dot' />
                            {device.deviceVersion && device.deviceVersion.name}
                          </label>
                        </CustomTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </Paper>

            <Grid container style={{ position: 'relative', marginBottom: 50 }}>
              <div style={{ position: 'absolute', right: '-25px' }}>
                <CustomFooter
                  count={count}
                  page={page}
                  rowsPerPage={this.props.limit}
                  rowsPerPageOptions={[]}
                  changePage={this.props.changePage}
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container style={{ padding: 20, justifyContent: 'space-between' }}>
            {/* <div className={classes.buttons}> */}
            <Button
              id='cancel'
              variant='outlined'
              color='primary'
              className={classes.button}
              onClick={this.props.handleClose}
            >
              {t('cancel')}
            </Button>
            {this.props.devices &&
            this.props.devices.data &&
            this.props.devices.data.length === 0 &&
            this.props.search === null ? (
              ''
            ) : (
              <Button
                id='add'
                variant='contained'
                onClick={this.props.handleSubmit}
                color='primary'
                className={classes.button}
                disabled={!this.props.disable}
              >
                {t('add')}
              </Button>
            )}
            {/* </div> */}
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#F9FAFB',
    color: '#667085',
    border: 'none',
    fontSize: 12,
    fontWeight: 500,
    borderTop: '1px solid #EAECF0',
    borderBottom: '1px solid #EAECF0',
    padding: '4px 20px 4px 12px',
  },
  body: {
    fontSize: 14,
    borderTop: '1px solid #EAECF0',
    borderBottom: 'none',
    padding: '4px 20px 4px 12px',
  },
}))(TableCell);

const styles = (theme) => ({
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textField: {
    fontWeight: 400,
    fontSize: 16,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  textColor: {
    color: theme.palette.text.primary,
  },
  textDisable: {
    color: theme.palette.text.hint,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    // marginLeft: theme.spacing.unit * 1,
    width: 100,
    borderRadius: '4px',
  },
  divider: {
    marginTop: '20px',
  },
  tableCellRadio: {
    width: '40px',
    padding: 4,
  },
  paperTable: {
    boxShadow: 'none',
    borderBottom: '1px solid #EAECF0',
  },
});

export const translation = withTranslation()(FixedEmergencyDeviceView);
export default withStyles(styles, { withTheme: true })(translation);
